import { render, staticRenderFns } from "./ListPartsOrder.vue?vue&type=template&id=1fc0ddbb"
import script from "./ListPartsOrder.vue?vue&type=script&lang=js"
export * from "./ListPartsOrder.vue?vue&type=script&lang=js"
import style0 from "./ListPartsOrder.vue?vue&type=style&index=0&id=1fc0ddbb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports